<script>
export default {
    props: {
        value: {}
    },
    methods: {
        doChange(inp) {
            this.$emit("change", inp.target.value);
        }
    }
};
</script>

<template>
    <select :value="value" @change="doChange" class="tri-state">
        <option value="">Ved ikke</option>
        <option value="0">Nej</option>
        <option value="1">Ja</option>
    </select>
</template>

<style lang="scss">
select.tri-state {
    border: 1px solid #ddd !important;
    background: white;
    border-radius: 4px;
}
</style>
